import type { Deal, DealStage } from '@/types'

export const REALIZED_MEETING_STATUSES = new Set([
  'Realizada',
  'Concluída',
  'REALIZADA',
  'CONCLUÍDA',
])

export function getLatestRealizedReuniao(deal: Pick<Deal, 'reunioes' | 'etapa'>) {
  const realized = deal.reunioes?.find((reuniao) => REALIZED_MEETING_STATUSES.has(reuniao.status))
  if (realized) return realized
  if (deal.etapa === 'reuniao_realizada' && deal.reunioes?.length) {
    return deal.reunioes[0]
  }
  return undefined
}

export function getMissingBantFields(deal: Pick<Deal, 'budgetConfirmado' | 'decisorPresente' | 'doresIdentificadas'>) {
  return [!deal.doresIdentificadas?.trim() && 'Observação'].filter(Boolean) as string[]
}

export function isBantComplete(deal: Pick<Deal, 'budgetConfirmado' | 'decisorPresente' | 'doresIdentificadas'>) {
  return getMissingBantFields(deal).length === 0
}

/** Negociação veio do funil BDR (handoff), não criação direta pelo closer. */
export function dealHasBdrHandoff(
  deal: Pick<Deal, 'instanceId' | 'bdrId' | 'bdrNome'>,
): boolean {
  return Boolean(deal.instanceId || deal.bdrId || deal.bdrNome?.trim())
}

export function cnpjMask(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 14)
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
}

export function onlyDigits(value: string): string {
  return value.replace(/\D/g, '')
}

export const stageProgression: Partial<Record<DealStage, DealStage>> = {
  qualificado: 'reuniao_agendada',
  reuniao_agendada: 'reuniao_realizada',
  reuniao_realizada: 'proposta_elaboracao',
  proposta_elaboracao: 'proposta_enviada',
  proposta_enviada: 'proposta_enviada',
  teste_gratis: 'gerar_contrato',
  renegociacao: 'proposta_enviada',
  gerar_contrato: 'contrato_enviado',
  contrato_enviado: 'handover',
  handover: 'ganho',
  ganho: 'ganho',
  perdido: 'perdido',
  pausado: 'pausado',
  fechamento_futuro: 'fechamento_futuro',
}
